<template>
    <div class="ml-5 mr-5">
        <b-loading :is-full-page="true" v-model="isFullScreenSearching" :can-cancel="true"></b-loading>
      
 
   
        <b-tabs v-model="searchTab">

            <b-tab-item label="Regular search"  icon="magnify">

                <b-field grouped @keyup.native.enter="keyEnterPress" >

                    <b-field label="OPD No."
                             :type="{ 'is-danger': hasErrorAllFieldBlank }"
                             :message="{ 'please some input to search': hasErrorAllFieldBlank }"
                    >
                        <b-input   v-model="OPDNo" placeholder="» » » » 63000001 « « « «"

                        ></b-input>

                    </b-field>


                    <b-field label="Pet Name"
                             :type="{ 'is-danger': hasErrorAllFieldBlank }"
                             :message="{ 'please some input to search': hasErrorAllFieldBlank }"  >
                        <b-input v-model="petName"  placeholder="» » » » » » แดง « « « « « «"
                        ></b-input>
                    </b-field>


                    <b-field label="Owner Name"
                             :type="{ 'is-danger': hasErrorAllFieldBlank }"
                             :message="{ 'please some input to search': hasErrorAllFieldBlank }" >
                        <b-input v-model="ownerName"  placeholder="» » » » » » สมชาย « « « « « « "
                        ></b-input>
                    </b-field>


                    <b-field label="Owner Surname"
                             :type="{ 'is-danger': hasErrorAllFieldBlank }"
                             :message="{ 'please some input to search': hasErrorAllFieldBlank }" >
                        <b-input v-model="ownersurname"  placeholder="» » » » » » นามสกุล « « « « « « "
                        ></b-input>
                    </b-field>


                    <b-field label="Search">
                        <b-button type="is-success" icon-left="magnify"  outlined @click="searchOPD" :disabled="isFullScreenSearching || !$v.OPDNo.maxLength"  ref="btnSearch"  ></b-button>
                    </b-field>


                    <b-field label="Clear All">
                        <b-button type="is-success" icon-left="close"  outlined @click="initDat"   ref="btnClearAll"  ></b-button>
                    </b-field>

                </b-field>

                <b-message type="is-danger" v-if="!$v.OPDNo.maxLength">
                    Error max length for OPD no. are 8 char
                </b-message>

                <b-message type="is-danger" v-if="!$v.OPDNo.integer">
                    Error   OPD no. must be numberic (not character)
                </b-message>

            </b-tab-item>

            <b-tab-item label="House number && Province search" icon="home-outline">
                <b-field grouped @keyup.native.enter="keyEnterPress" >
                    <b-field label="House number"
                             :type="{ 'is-danger': hasErrorHomeAddressFieldBlank }"
                             :message="{ 'please some input to search': hasErrorHomeAddressFieldBlank }"
                    >
                        <b-input   v-model="homeaddress" placeholder="» » » » 11/112 « « « «"

                        ></b-input>
                    </b-field>
                    <b-field label="Province">
                        <b-select placeholder="Select a name" v-model="provinceSelected">
                            <option
                                    v-for="provinceDat in province"
                                    :value="provinceDat.id"
                                    :key="provinceDat.id"
                            >
                                {{ provinceDat.name }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field label="Search">
                        <b-button type="is-success" icon-left="magnify"  outlined @click="searchOPD" :disabled="isFullScreenSearching"  ref="btnSearch"  ></b-button>
                    </b-field>
                    <b-field label="Clear All">
                        <b-button type="is-success" icon-left="close"  outlined @click="initDat"   ref="btnClearAll"  ></b-button>
                    </b-field>
                </b-field>

            </b-tab-item>
        </b-tabs>




    

        <b-table
                :data= "isEmpty ? []  : opdResultSearch"
                bordered
                striped
                hoverable

        >


            <b-table-column field="id" label="OPD No."  centered  v-slot="props" >
                
                     <!-- {{props.row.idopd}} -->
                <!-- <b-dropdown aria-role="menu">
                    <template #trigger="{ active }">
                        <b-button
                            type="is-primary"
                            :icon-right="active ? 'menu-up' : 'menu-down'" >
                          {{props.row.idopd}}  
                        </b-button>
                    </template>
               

                    <b-dropdown-item aria-role="listitem" @click="selectOPDNoToVetroom(props.row)" >to Vetroom</b-dropdown-item>
                    <b-dropdown-item aria-role="listitem" @click="selectOPDNoToOrder(props.row.idopd,props.row)" >to Order</b-dropdown-item>
                </b-dropdown> -->

                <b-tooltip position="is-top" multilined type="is-info"> 
                     <b-button type="is-info"   
                          @click="selectOPDNo(props.row)"
                          >
                        {{ props.row.idopd }}
                     </b-button>
                    <template v-slot:content>
                        เลือก <b>{{ props.row.idopd }}</b><br/>
                         <i>{{ props.row.name }}</i><br/>
                         <b>{{ props.row.owner_name }}</b>
                      
                    </template>
                </b-tooltip> 
                
            </b-table-column>

            <b-table-column field="name" label="Pet Name" centered v-slot="props">
                {{ props.row.name }}
            </b-table-column>

            <b-table-column field="owner_name" label="Owner Name" centered v-slot="props">
                {{ props.row.owner_name }}
            </b-table-column>

            <b-table-column field="age" label="Age" centered v-slot="props">
                {{ props.row.age }}
            </b-table-column>

            <b-table-column label="Gender" v-slot="props">
                            <span>
                                <b-icon
                                        :icon="props.row.sex === 'M' ? 'gender-male' : 'gender-female'">
                                </b-icon>
                            </span>
            </b-table-column>

            <b-table-column field="species" label="Species" centered v-slot="props">
                {{ props.row.species }}
            </b-table-column>


            <b-table-column field="breed" label="Breed" centered v-slot="props">
                {{ props.row.breed }}
            </b-table-column>

            <b-table-column field="address" label="Address" centered v-slot="props">
                {{ props.row.address }}
            </b-table-column>

            <b-table-column field="address" label="Mobile Phone" centered v-slot="props">
                {{ props.row.phone_mobile }}
            </b-table-column>
 
            <!-- <b-table-column field="address" label="Check in ?" centered v-slot="props">
                        <b-icon
                            :icon="props.row.visit_active  ? 'check-bold' : 'close-circle-outline'"
                            :type="props.row.visit_active  ? 'is-info' : 'is-danger' "  
                            size="is-small"

                        >
                        </b-icon>
               <span v-if="userIsAdmin && props.row.visit_active" class="has-text-info"> ( visit no. {{props.row.visit_active}} )</span>               
            </b-table-column> -->

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                    icon="table-search"
                                    size="is-large">
                            </b-icon>
                        </p>
                        <p>Nothing here.</p>
                    </div>
                </section>
            </template>


            <template slot="footer"  >
                <div class="box">
                    <div  class="level-left" >    </div>
                    <div  class="level-right" >
                        <b-button type="is-primary" outlined 
                           v-show="opdResultSearch.length>0"   
                           :disabled="isDisableMoreBtn" 
                           :loading="isMoreBtnLoading" @click="doFilter('m')"  >More..</b-button>
                    </div>
                </div>
            </template>


        </b-table>




         

    

    </div>
</template>

<script>

    import { maxLength ,integer } from 'vuelidate/lib/validators'
    import { mapState ,mapMutations } from "vuex";
    import { getBaseURLforBackEnd , getConfigAxios  ,firstSelectParam  } from '@/utils.js'
    import axios from "axios"
    

     

    export default {
        name: "HNSelection",

        validations:{
            OPDNo :{
                maxLength :   maxLength(8),
                integer
            }
        },
        components:{
       
        },
        computed:{
            ...mapState({
                // userInfo : state => state.master_data.userInfo ,.
                user_id : state => state.master_data.user_id ,
                userName : state => state.master_data.userName ,
                userIsAdmin  : state => state.master_data.userIsAdmin ,
                province : state => state.master_data.province ,
                access_token: state => state.master_data.access_token ,
                opdResultSearch : state => state.patho_opd_job_worklist.opdResultSearch ,
                // currentVisitNo :  state => state.vetroom.currentVisitNo ,
            }) ,


        },
        methods:{

            ...mapMutations({
                setOpdResultSearch : 'patho_opd_job_worklist/setOpdResultSearch'
            }),

            // ...mapActions({
            //     produceOpdInfoInVetRoom: 'vetroom/produceOpdInfoInVetRoom',
            //     produceCurrentVisitNo : 'vetroom/produceCurrentVisitNo'
            // }),

            
           
           
            //  HN *************************************  
            // closeHN(){
            //     this.isHNShowing = false
            // },
            // newHN(){
            //     this.modeHN = 'I'
            //     this.isHNShowing = true
            // },


           selectOPDNo(_data){
               console.log(_data)
               this.$emit('HNSelected',_data)
           },
         
            
            
            
            closeTakeMemoOrder(){
                this.isTakeMemoOrderShowing = false
            },

          
            selectOPDNoToOrder(_idopd,_opdinfo){
                this.opdNoSelectFotTakeOrder = _idopd
                // console.log(_opdinfo)
                // _opdinfo.opd_name = _opdinfo.name
                // _opdinfo.owner =  _opdinfo.owner_name
                this.opdInfo = _opdinfo

                // console.log(_idopd)
                // console.log(_opdinfo)

                this.isTakeMemoOrderShowing = true
            },
            keyEnterPress(){
                if (this.$v.OPDNo.maxLength && this.$v.OPDNo.integer){
                    this.searchOPD()
                }
            },
            searchOPD() {

                // const vm  = this


                if(this.searchTab === 0){
                    // check all blank
                    if (this.OPDNo.length === 0 && this.petName.length === 0 && this.ownerName.length === 0 && this.ownersurname.length === 0  ) {
                        this.hasErrorAllFieldBlank = true
                        return
                        // check OPD No. only
                    } else if (this.OPDNo.length < 3 && this.petName.length === 0 && this.ownerName.length === 0 && this.ownersurname.length === 0 ) {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Should more than 3 character for search OPD No. only!',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'close-octagon',
                            // iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return
                        // Pet Name Only
                    } else if (this.OPDNo.length === 0 && this.petName.length < 2 && this.ownerName.length === 0 && this.ownersurname.length === 0  ) {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Should more than 2 character for search pet name only!',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'close-octagon',
                            // iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return
                        //  ownerName Only
                    } else if (this.OPDNo.length === 0 && this.petName.length === 0 && this.ownerName.length < 3 && this.ownersurname.length === 0  ) {
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Should more than 3 character for search owner name only!',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'close-octagon',
                            // iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return
                        //  ownerSurName Only
                    } else if(this.OPDNo.length===0 && this.petName.length ===0  && this.ownerName.length === 0 && this.ownersurname.length <3   ){
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: 'Should more than 3 character for search owner surname only!',
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'close-octagon',
                            // iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        return
                    } else{
                        this.doFilter('f')
                    }
                }
                else{
                    if (this.homeaddress.length === 0) {
                        this.hasErrorHomeAddressFieldBlank = true
                        return
                    } else{
                        this.doFilter('f')
                    }
                }
            },
            doFilter(firstFreshOrMore){
                // fresh === 'f' , more === 'm'
                if(!this.user_id){
                    this.$router.push('/login')
                        .catch(()=>{});
                    return
                }

                this.hasErrorAllFieldBlank = false
                this.isFullScreenSearching = true
                this.isShowSearchInfo = false
                if(firstFreshOrMore === 'f') {
                    // this.opdResultSearch = []
                    this.setOpdResultSearch([])  
                    this.skipQrySelect  = 0
                    this.isDisableMoreBtn = false
                    this.dataOwnerMore = []
                }
                this.isTblLoading = true

                //****************************
                if(firstFreshOrMore === 'm'){
                    this.skipQrySelect =   this.skipQrySelect +firstSelectParam()
                    this.isMoreBtnLoading = true
                }else{
                    this.isMoreBtnLoading = false
                }

                const datToFilter =
                    {
                        "type": this.searchTab === 0 ? "1" : "2",
                        "first":  firstSelectParam(),
                        "skip": this.skipQrySelect ,
                        "dat_type1":{
                            "idopd": this.OPDNo,
                            "owner": this.ownerName ,
                            "ownersurname": this.ownersurname,
                            "opdname": this.petName,
                            "idown" : ""
                        } ,
                        "dat_type2" :{
                            "homeaddress": this.homeaddress,
                            "idprovince":  this.provinceSelected
                        },
                        "user": this.userName,
                        "ip": '0.0.0.0'

                    }

                console.log(JSON.stringify(datToFilter))
                var vm = this
                // attach access_token it
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/search_opd_v2`,datToFilter,getConfigAxios())
                    .then(function (response) {
                        if(firstFreshOrMore === 'f') {
                            vm.setOpdResultSearch(response.data)
                            // console.log(response.data)
                            // vm.opdResultSearch = response.data
                        } else{
                            const tmp = vm.opdResultSearch.concat(response.data)
                            vm.setOpdResultSearch(tmp)
                            // vm.opdResultSearch =vm.opdResultSearch.concat( response.data )
                        }
                        vm.isFullScreenSearching = false
                        vm.isTblLoading = false
                        if(firstFreshOrMore === 'm'){
                            vm.isMoreBtnLoading = false
                            if (response.data.length === 0){
                                vm.isDisableMoreBtn = true
                                vm.$buefy.dialog.alert({
                                    title: 'Infomation',
                                    message: 'Nothing to load any more',
                                    type: 'is-info',
                                    hasIcon: true,
                                    icon: 'database-export-outline',
                                    // iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true
                                })
                            }
                        }
                    })
                    .catch( function(err) {
                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')
                        }
                    })




            },
            initDat(){
                this.hasErrorAllFieldBlank = false,
                this.hasErrorHomeAddressFieldBlank = false
                this.OPDNo = ''
                this.setOpdResultSearch([])
                // this.opdResultSearch = []
                this.ownerName = ''
                this.petName = ''
                this.ownersurname = ''
                this.homeaddress = ''
                this.provinceSelected = '10'
            }
        },
        data(){
            return{
                OPDNo : "",
                petName:"",
                ownerName :"",
                ownersurname : "",

                searchTab : 0,
                skipQrySelect : 0,

                hasErrorAllFieldBlank: false,
                hasErrorHomeAddressFieldBlank : false,
                isFullScreenSearching : false ,

                isMoreBtnLoading : false ,
                isDisableMoreBtn : false ,
                homeaddress : "",
                provinceSelected : '10', // Bangkok,


                // opdResultSearch :[],

                isEmpty : false,

                isTakeMemoOrderShowing: false,
                opdNoSelectFotTakeOrder : "",

                opdInfo : {},


                // HN
                isHNShowing : false,
                modeHN : 'I',
                
                
            }
        }
    }
</script>

<style scoped>

</style>